/*
 * @Descripttion: 
 * @Author: chenjie
 * @Date: 2021-10-25 10:22:05
 * @LastEditors: chenjie
 * @LastEditTime: 2021-10-28 15:47:15
 */

import axios from '@/axios'

/**
 * @Author: chenjie
 * @Date: 2021-10-25 10:29:02
 * @Descripttion: 获取首页信息门户的新闻
 * @params {*}
 * @param {*} type
 */
export function getArticle(type){
  return  axios({
    url:'/zhanjiang-portal/frontInformation/getArticle/' + type,
    method:'get'
  })
}
/**
 * @Author: chenjie
 * @Date: 2021-10-25 10:29:02
 * @Descripttion: 获取首页信息门户湛鱼生态链
 * @params {*}
 * @param {*} type
 */
export function getEcologicalChain(chain){
  return  axios({
    url:'/zhanjiang-portal/frontInformation/getEcologicalChain/' + chain,
    method:'get'
  })
}
/**
 * @Author: chenjie
 * @Date: 2021-10-25 10:29:02
 * @Descripttion: 获取首页信息门户的入驻企业Logo
 * @params {*}
 * @param {*} type
 */
export function getLogo(type){
  return  axios({
    url:'/zhanjiang-portal/frontInformation/getLogo/' + type,
    method:'get'
  })
}
/**
 * @Author: chenjie
 * @Date: 2021-10-25 10:29:02
 * @Descripttion: 获取首页信息门户数字渔业园区
 * @params {*}
 * @param {*} type
 */
export function getParkInformationByNew(type){
  return  axios({
    url:'/zhanjiang-portal/frontInformation/getParkInformationByNew',
    method:'get'
  })
}
/**
 * @Author: chenjie
 * @Date: 2021-10-25 10:29:02
 * @Descripttion: 获取首页信息门户图片
 * @params {*}
 * @param {*} type
 */
export function getVideo(type){
  return  axios({
    url:'/zhanjiang-portal/frontInformation/getVideo',
    method:'get'
  })
}